import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Navbar from "./Navbar";
import { PROGRAM_TYPES } from "./constants/programTypes";
import EnrollmentCenterInfoPage from "./EnrollmentCenterInfoPage";
import WaitTimes from "./WaitTimes";
import WaitTimesProgramPicker from "./WaitTimesProgramPicker";
import { Box } from "@chakra-ui/react";
import Footer from "./Footer";
import { Helmet } from "react-helmet";

export default function App() {
  return (
    <Router basename="/locations">
      <Navbar />
      <Switch>
        <Route path="/global-entry/:locationString">
          <EnrollmentCenterInfoPage programType={PROGRAM_TYPES.GLOBAL_ENTRY} />
        </Route>
        <Route path="/sentri/:locationString">
          <EnrollmentCenterInfoPage programType={PROGRAM_TYPES.SENTRI} />
        </Route>
        <Route path="/nexus/:locationString">
          <EnrollmentCenterInfoPage programType={PROGRAM_TYPES.NEXUS} />
        </Route>
        <Route path="/global-entry">
          <Helmet>
            <title>Global Entry Interview Wait Times</title>
          </Helmet>
          <WaitTimes programType={PROGRAM_TYPES.GLOBAL_ENTRY} />
        </Route>
        <Route path="/sentri">
          <Helmet>
            <title>SENTRI Interview Wait Times</title>
          </Helmet>
          <WaitTimes programType={PROGRAM_TYPES.SENTRI} />
        </Route>
        <Route path="/nexus">
          <Helmet>
            <title>NEXUS Interview Wait Times</title>
          </Helmet>
          <WaitTimes programType={PROGRAM_TYPES.NEXUS} />
        </Route>
        <Route path="/">
          <WaitTimesProgramPicker />
        </Route>
      </Switch>
      <Footer />
    </Router>
  );
}
